import api, { money } from "@/mechanic/lib/api";
import InvoiceManager from "@/components/invoices/InvoiceManager";

// The mechanic shell's <main> has no padding of its own — every page in this
// module supplies it. The rental shell pads in <main>, so the shared manager
// stays padding-free and each consumer owns its own spacing.
export default function Invoices() {
  return (
    <div className="p-8">
      <InvoiceManager
        api={api}
        module="mechanic"
        title="Invoices"
        subtitle="Create from a work order, search existing work orders, or build a blank invoice and enter all the job info manually. Custom business name & logo per invoice when needed."
        allowBranding
        sourceConfig={{
          label: "Work Order",
          listPath: "/work-orders",
          id: (w) => w.id,
          optionLabel: (w) => `${w.vehicle_label || "Vehicle"} · ${w.complaint || "Service"} · ${money(w.totals?.total)}`,
          search: [
            { key: "vehicle", label: "Vehicle", get: (w) => w.vehicle_label },
            { key: "complaint", label: "Service / complaint", get: (w) => w.complaint },
            { key: "mechanic", label: "Mechanic", get: (w) => w.mechanic_name },
          ],
        }}
      />
    </div>
  );
}
